/** Serenity + musicalidad — paleta del home */
export const HOME_THEME = {
  /** Casi negro con profundidad cálida */
  bg: "#100f0e",
  bgWarmGlow: "rgba(42, 32, 38, 0.45)",
  /** Blanco roto con levísima calidez */
  text: "#f3efe8",
  textGradient: "linear-gradient(165deg, #f6f2eb 0%, #ebe4f4 48%, #e8f5f0 100%)",
  /** Secundarios derivados de lavanda / menta */
  muted: "#a89eb8",
  dim: "#6d6478",
  lavender: "#c4b5fd",
  lavenderSoft: "#9b8ec4",
  mint: "#99f6e4",
  mintSoft: "#7ecfc0",
  /** Acentos pedagógicos — mástil */
  tonic: "#f0a8a0",
  staffLine: "rgba(228, 218, 240, 0.55)",
  lineItem: "rgba(196, 181, 253, 0.08)",
  lineHover: "rgba(196, 181, 253, 0.14)",
  glowLavender: "rgba(196, 181, 253, 0.12)",
  glowMint: "rgba(153, 246, 228, 0.1)",
  glowLavenderExpansive: "0 0 120px 40px rgba(196, 181, 253, 0.18), 0 0 60px 20px rgba(196, 181, 253, 0.08)",
  glowMintExpansive: "0 0 120px 40px rgba(153, 246, 228, 0.16), 0 0 60px 20px rgba(153, 246, 228, 0.07)",
} as const;

/** Indicadores junto a estadísticas del hero */
export const HOME_STAT_ACCENTS = [
  HOME_THEME.tonic,
  HOME_THEME.lavender,
  HOME_THEME.mint,
  HOME_THEME.lavenderSoft,
] as const;

export const PILLARS = [
  {
    id: "explore",
    title: "Explorar",
    subtitle: "Libre",
    path: "/explore",
    hover: "lavender" as const,
  },
  {
    id: "learn",
    title: "Aprender",
    subtitle: "Guiado",
    path: "/learn",
    hover: "mint" as const,
  },
  {
    id: "play",
    title: "Tocar",
    subtitle: "Repertorio",
    path: "/play",
    hover: "lavender" as const,
  },
] as const;
